import request from "@/axios";


/* 获取支付入口来源列表 */
export const paySourceList = (data) => {
  return request({
    url: "/lebo-member/web/member/paySource/list",
    method: "get",
    params: data
  });
}


/* 新增支付入口来源 */
export const paySourceSave = (data) => {
  return request({
    url: "/lebo-member/web/member/paySource/save",
    method: "post",
    data
  });
}


/* 查询列表 */
export const configPage = (data) => {
  return request({
    url: "/lebo-member/web/member/config/page",
    method: "get",
    params: data
  });
}

/* 根据会员查询端类型列表 */
export const typeListByType = (params) => {
  return request({
    url: "/lebo-member/web/member/type/listByType",
    method: "get",
    params
  });
}

/* 新增支付配置来源 */
export const configSave = (data) => {
  return request({
    url: "/lebo-member/web/member/config/save",
    method: "post",
    data
  });
}

/* 编辑支付配置来源 */
export const configUpdate = (data) => {
  return request({
    url: "/lebo-member/web/member/config/update",
    method: "post",
    data
  });
}


/* 删除支付配置来源 */
export const configDelByIds = (data) => {
  return request({
    url: "/lebo-member/web/member/config/delByIds",
    method: "get",
    params: data
  });
}

/* 获取详情 */
export const getDetail = (data) => {
  return request({
    url: "/lebo-member/web/member/config/getById",
    method: "get",
    params: data
  });
}

/** 导入手机号列表 */
export const importPhoneList = (data) => {
  return request({
    url: '/lebo-member/web/member/config/importPhone',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/** 下载手机号文件 */
export const downloadPhoneFile = (data) => {
  return request({
    url: '/lebo-member/web/member/config/exportPhone',
    method: 'get',
    params: data,
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/octet-stream"
    }
  })
}
